<div class="dataRow">
  <!-- <input type="checkbox" [attr.id]="'checkbox'+rowObj.customerEU"
     (change)="onCustomerSelected($event)" [checked]="rowObj.checked">
  <label [attr.for]="'checkbox'+rowObj.customerEU">{{rowObj.customerEU}}</label> -->
  <label class="custom-checkbox">
    <span>{{rowObj.customerEU}}</span>
    <input type=checkbox name="rowObj.customerEU" [checked]="rowObj.checked" (change)="onCustomerSelected($event)">
    <span class="checkmark"></span>
  </label>
</div>